export default [
  {
    path: '/import/user',
    name: 'Import Tracks User',
    component: () =>
      import(/* webpackChunkName: 'import-user' */ './views/User.vue')
  },
  {
    path: '/import/admin',
    name: 'Import Tracks Admin',
    component: () =>
      import(/* webpackChunkName: 'import-admin' */ './views/Admin.vue')
  },
  {
    path: '/import/distro',
    name: 'Import Distro Tracks',
    component: () =>
        import(/* webpackChunkName: 'import-distro' */ './views/Distro.vue')
  },
  {
    path: '/import/analyze',
    name: 'Analyze Track',
    component: () =>
        import(/* webpackChunkName: 'import-recognize' */ './views/Recognize.vue')
  }
]
